var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOtherrecommendation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "other-recommendation",
    transform: "translate(-765 -167)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_270",
    "data-name": "Ellipse 270",
    cx: 35,
    cy: 35,
    r: 35,
    transform: "translate(765 167)",
    fill: "#004b75",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1417",
    "data-name": "Group 1417",
    transform: "translate(786 188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1416",
    "data-name": "Group 1416",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M34.074,10.6l-3.411,3.411a9.987,9.987,0,1,0,.461.886l3.624-3.624a.476.476,0,0,0-.673-.673Zm-3,8.433a9.054,9.054,0,1,1-1.106-4.33l-7.942,7.942-3-3a.476.476,0,0,0-.673.673l3.334,3.334a.476.476,0,0,0,.673,0L30.4,15.622A8.986,8.986,0,0,1,31.077,19.037Z",
    transform: "translate(-6.314 -4.75)",
    fill: "#004c75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M1.9,28.574H18.1a1.9,1.9,0,0,0,1.9-1.9v-1.9a.476.476,0,0,0-.952,0v1.9a.952.952,0,0,1-.952.952H1.9a.952.952,0,0,1-.952-.952v-20H5.238A1.429,1.429,0,0,0,6.667,5.238V.952H18.1a.952.952,0,0,1,.952.952v1.9a.476.476,0,1,0,.952,0V1.9A1.9,1.9,0,0,0,18.1,0H6.586a1.418,1.418,0,0,0-.571.122C6.005.125,6,.131,5.99.135a1.423,1.423,0,0,0-.413.286L.419,5.575a1.423,1.423,0,0,0-.286.413C.129,6,.123,6,.12,6.013A1.418,1.418,0,0,0,0,6.586V26.669A1.9,1.9,0,0,0,1.9,28.574ZM5.715,1.626V5.238a.476.476,0,0,1-.476.476H1.626Z",
    transform: "translate(0)",
    fill: "#004c75"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherrecommendation);
export default __webpack_public_path__ + "static/media/Otherrecommendation.c6a701ce186539462b11f509398230f4.svg";
export { ForwardRef as ReactComponent };